
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/devices",
      function () {
        return require("private-next-pages/devices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/devices"])
      });
    }
  